<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="'Édition du tiers'"
      :subtitle="t ? t.name : ''">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <tiers-form
          :source-loading="loading"
          :source-tiers="t"
          @submit="updateTiers"></tiers-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import TiersMixin from './TiersMixin'

export default {
  name: 'TiersEdit',
  components: {
    TiersForm: () => import('@/components/tiers/TiersForm')
  },
  mixins: [TiersMixin]
}
</script>
